// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-G":"G_amazon-sale-G__k7HUf"};